import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewslettersListComponent } from './components/newsletters-list/newsletters-list.component';

const routes: Routes = [
  {
    path: '', component: NewslettersListComponent, data: { title: '' }    
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewslettersRoutingModule { }
